export default __webpack_public_path__ + "static/media/staggeringblow1.f3baabd4.png";